import React, { memo } from "react";

import SportsbookWrapper from "../sportsbookWrapper";

const Live = () => <SportsbookWrapper gameType="live" />;

export default memo(Live);
